module.exports = __webpack_public_path__ + "img/img_028@2x.6834e82a.png";